import { useParams } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client/core/networkStatus';

import { FullScreenProgress, Typography } from '@occc-app/design-system';
import { useGetActivateTransactionById } from '@occc-app/dataAccessLayer/activateTransaction/queries';

import { MemberTransactionDetailsPage } from './MemberTransactionDetailsPage';
import { errorMessage, noDataMessage } from './copies';

export const MemberTransactionDetailsPageContainer = () => {
  const { id = '' } = useParams<{ id: string }>();

  const {
    data: activateTransaction,
    error,
    loading,
    networkStatus,
  } = useGetActivateTransactionById(id);

  if (loading && networkStatus !== NetworkStatus.refetch) return <FullScreenProgress />;

  if (error) {
    return (
      <Typography color='error' data-testid='something-went-wrong-msg'>
        {errorMessage}
      </Typography>
    );
  }

  if (!activateTransaction) {
    return (
      <Typography color='error' data-testid='no-data-msg'>
        {noDataMessage}
      </Typography>
    );
  }

  return <MemberTransactionDetailsPage transaction={activateTransaction} />;
};
